import {IntegerParameter} from 'parameters/AbstractParameter.js';

export default superclass => class extends superclass  {
    setupTrackParameter() {
        this.trackParameter = new IntegerParameter(
            'track', this,
            (o, x) => {
                this.onChangeTrack(x);
            },
            {
                defaultValue: -1,
                min: 0,
                max: 10,
                isAutomatable: false // cant automate track connect/disconnect
            });

        this._track = undefined;
    }

    onChangeTrack(track) {
        if (track === -1) {
            this._track = undefined;
            return;
        }
        this._track = this.sequencerEngine.tracks[track];
    }

    getTrack() {
        let track = this.trackParameter.get();
        if (track === -1) {
            return undefined;
        }

        return this.sequencerEngine.tracks[track];
    }
}
